import { createStyles, makeStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: '#fff',
      position: 'fixed',
      zIndex: 1400,
      lineHeight: '2rem',
      display: 'flex',
      alignItems: 'center',
      height: '4rem',
      '& > div': { display: 'flex', height: '100%' },
      '& > div div': { display: 'block', height: '100%', margin: '0 auto', lineHeight: '4rem' }
    },
    logoLinkWrapper: {
      '& > a': { display: 'flex', height: '100%' },
      '& > a > div': { backgroundSize: '100%' }
    },
    contentBurger: {
      cursor: 'pointer',
      verticalAlign: 'middle',
      width: '2rem',
      height: '2rem',
      '& > svg': { display: 'block', margin: 'auto', height: '100%' },
      '&:focus': {
        outline: 'unset'
      }
    },
    svgClosed: {
      fontSize: '1.8rem',
      height: '1.8rem',
      transitionTimingFunction: 'ease-in',
      transition: '0.4s'
    },
    svgMenuToggle: {
      fill: '#fff',
      pointerEvents: 'all',
      cursor: 'pointer'
    }
  })
)
